export const SnowPlowGBCookie: string = 'snowplow_anonymous_id';
export const SnowPlowIDCookie: string = 'spid';
export const GrowthBookExperimentsCookie: string = 'GrowthBook_experiments';
